/***************************************************************************/
"use client";
/***************************************************************************/

import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";
import { CardContext } from "./card";

const cardHeaderVariants = cva("--header flex flex-col gap-1", {
  variants: {
    size: {
      default: "px-4 pt-5",
      sm: "px-3 pt-3",
      lg: "px-5 pt-6",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  const { size } = React.useContext(CardContext);

  return (
    <div
      ref={ref}
      className={cn(cardHeaderVariants({ size }), className)}
      {...props}
    />
  );
});
CardHeader.displayName = "CardHeader";

export { CardHeader, cardHeaderVariants };
